<template>
  <div
    class="group flex cursor-pointer gap-2 text-new-black shadow-none transition duration-300"
  >
    <MainPageCardsReworkedCommonCardImageBlock
      disable-label
      v-bind="{ data }"
      class="relative col-span-1 h-[67px] w-[120px] min-w-[120px] rounded-lg"
    >
    </MainPageCardsReworkedCommonCardImageBlock>
    <div class="col-span-2 flex flex-col">
      <h2
        class="text-clamp-2 z-30 font-roboto text-[16px] font-semibold leading-[22px]"
      >
        {{ data.title }}
      </h2>

      <p
        class="text-clamp-1 z-30 mt-2 text-[12px] font-semibold leading-[14px] text-[#808080]"
      >
        {{ categoryTitle }}
      </p>
    </div>
  </div>
</template>

<script setup>
defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
  categoryTitle: { type: String, default: '' },
  // isTitleCard: { type: Boolean, default: false },
  // disablePlay: { type: Boolean, default: false },
  // disablePreview: { type: Boolean, default: false },
  // aspect: {
  //   type: Object,
  //   default: () => ({
  //     w: 16,
  //     h: 9,
  //   }),
  // },
});
// const getCardSettings = useCardSettings();

// const getDataByModel = computed(() => {
//   return getCardSettings(props.data);
// });

// const getUrl = computed(() => {
//   return (
//     props.data?.url ?? `${getDataByModel.value?.hrefBase}${props.data?.slug}`
//   );
// });
</script>
